/** Free tools promoted on advertise + partner market pages. */

export const CASAMAPA_PARTNER_FREE_TOOL_KEYS = Object.freeze([
  "heatmap",
  "brief",
  "pulse",
  "health",
  "comps",
  "inbox",
]);

/** Market-intelligence tools shown first on /partner/market. */
export const CASAMAPA_PARTNER_MARKET_INTEL_TOOL_KEYS = Object.freeze([
  "heatmap",
  "brief",
  "pulse",
]);

/** Inventory / response tools also listed on the market hub. */
export const CASAMAPA_PARTNER_WORKSPACE_TOOL_KEYS = Object.freeze([
  "health",
  "comps",
  "inbox",
]);

/**
 * @typedef {{
 *   portalSegment: string,
 *   available: boolean,
 *   status: "live" | "preview",
 *   ctaKey?: string,
 * }} CasaMapaPartnerFreeTool
 */

/** @type {Readonly<Record<string, CasaMapaPartnerFreeTool>>} */
export const CASAMAPA_PARTNER_FREE_TOOLS = Object.freeze({
  heatmap: {
    portalSegment: "market/heatmap",
    available: true,
    status: "live",
    ctaKey: "openHeatmap",
  },
  brief: {
    portalSegment: "market/brief",
    available: true,
    status: "live",
    ctaKey: "openBrief",
  },
  pulse: {
    portalSegment: "market/pulse",
    available: true,
    status: "live",
    ctaKey: "openPulse",
  },
  health: {
    portalSegment: "listings",
    available: true,
    status: "live",
    ctaKey: "openHealth",
  },
  // Comp set opens from a listing health detail page.
  comps: {
    portalSegment: "listings",
    available: true,
    status: "live",
    ctaKey: "openComps",
  },
  inbox: {
    portalSegment: "leads",
    available: true,
    status: "live",
    ctaKey: "openInbox",
  },
});
